export default __webpack_public_path__ + "static/media/stoyan_l.53c9c7fe.jpg";